import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fd93b53e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd93b53e')) {
      api.createRecord('fd93b53e', component.options)
    } else {
      api.reload('fd93b53e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fd93b53e&", function () {
      api.rerender('fd93b53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LzBGwioT68KP/JS/comp/ErrorMessage.vue"
export default component.exports